import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
const ExpenseEdit = lazyLoader(
  () => import("Containers/Expense/ExpenseUpdate/ExpenseUpdate"),
);
export const EditExpensePage = () => {
  return (
    <Layout>
      <ExpenseEdit />
    </Layout>
  );
};
